export default __webpack_public_path__ + "static/illustration-content.url-0ba6c2c34759f2545fcc4d2c9c136a84.svg";